<template>
  <div id="Videos">
    <h2 class="componentheader">Videos</h2>
    <p>Check out the latest videos.</p>
    <div class="video container-xl"
      v-for="(video, index) in videos"
      :key="video.id"
    >
      <div class="row">
        <div class="col-lg-3">
          <h3 class="videoTitle" @click="goToLink(index)">{{ video.title }}</h3>
          <div class="videoDesc">{{ video.description }}</div>
        </div>
        <lazy-component tag="div" class="youtubeEmbed col-lg-9">
          <iframe width="560" height="315" :src="video.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </lazy-component>
      </div>
    </div>
  </div>
</template>

<script>

import db, { Timestamp } from '@/db'

export default {
  name: 'Videos',
  data () {
    return {
      selectedVideo: '',
      selectedUrl: '',
      videos: []
    }
  },
  created () {
    var serverTime = Timestamp.fromDate(new Date())
    db.collection('videos').where('date', '<=', serverTime).orderBy('date', 'desc').limit(5).get().then(snapshot => {
      snapshot.forEach(doc => {
        const id = doc.id
        var date = doc.data().date
        const description = doc.data().description
        const title = doc.data().title
        const url = doc.data().url
        const urlDirect = doc.data().urlDirect
        const options = {
          year: 'numeric', month: 'long', day: 'numeric'
        }
        date = new Intl.DateTimeFormat('en-US', options).format(date.seconds * 1000)

        const video = {
          id,
          date,
          description,
          title,
          url,
          urlDirect
        }

        this.videos.push(video)
      })
    })
  },
  methods: {
    goToLink: function (index) {
      this.selectedVideo = index
      this.selectedUrl = this.videos[this.selectedVideo].urlDirect
      location.href = this.selectedUrl
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.videoTitle:hover, .videoTitle:focus {
    transform: scale(1.1);
    font-weight: bold;
    cursor: pointer;
}

.videoDesc {
    margin-bottom: .5em;
}

.videoTitle {
  padding-bottom: .3em;
}

</style>



// WEBPACK FOOTER //
// src/components/Videos.vue